module.exports = __webpack_public_path__ + "img/435916709.0d608147.jpg";